import { render, staticRenderFns } from "./marquee-image.vue?vue&type=template&id=2fb55e3d&scoped=true&"
import script from "./marquee-image.vue?vue&type=script&lang=js&"
export * from "./marquee-image.vue?vue&type=script&lang=js&"
import style0 from "./marquee-image.vue?vue&type=style&index=0&id=2fb55e3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb55e3d",
  null
  
)

export default component.exports